var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"11","height":"10","viewBox":"0 0 11 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.19447 9.30664L-0.00167847 0.306641L10.3906 0.306641L5.19447 9.30664Z","fill":"#0E3B4D"}})])}
var staticRenderFns = []

export { render, staticRenderFns }